import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'src/app/_models/subscription';
import { AuthService } from '../../_services/auth.service';
import { StudentService } from '../../_services/student.service';
import { GatePass } from './../../_models/gate_pass';
import { AdminService } from './../../_services/admin.service';
import { GuardianService } from './../../_services/guardian.service';



declare var window: any;

@Component({
  selector: 'app-enrolment-student-list',
  templateUrl: './enrolment-student-list.component.html',
  styleUrls: ['./enrolment-student-list.component.css']
})
export class EnrolmentStudentListComponent implements OnInit {
  enrollments=[]
  server_student_user_id=0
  current_server_enrolment_id=0
  subscription:Subscription= new Subscription()
  studentDetail:any=undefined
  guardian= undefined
  loading = false
  adminExtending=false
  adminUpgrading=false
  enrolTrialLoading=false

  trialModal:any
  upgradeModal:any
  myTrialEnrolmentModalName="myTrialEnrolmentModal"
  myUpgradeEnrolmentModalName="myUpgradeEnrolmentModal"
  adminEnrolExtendModalName="enrolAdminExtendModal"
  enrolAdminExtendModal:any
  enrolment_extend_id:number

  can_change_level=false
  admin_extend=false
  self_upgrade=false
  admin_upgrade=false

  add_trial =false
  add_trial_admin =false
  gatePass:GatePass=new GatePass()


  constructor(
    public authService:AuthService,
    private adminService:AdminService,
    private route:ActivatedRoute,
    private studentService:StudentService,
    private guardianService:GuardianService
    ) { }

  ngOnInit(): void {

    this.loading=true
    this.route.params.subscribe(params => {
    this.server_student_user_id = params['server_student_user_id']

     if(this.server_student_user_id!=0){
      this.studentService.getLearner(this.server_student_user_id).subscribe(
        x=>{
          this.studentDetail=x

          this.subscription = this.studentDetail['subscription_object']
          if(this.subscription){
            this.current_server_enrolment_id=this.subscription.server_enrolment_id
          }else{
            this.subscription = new Subscription()
          }

          this.initGuardianStudent()
          this.loadEnrollments()
          this.initDecisionStates()
          this.loading=false
        }
      )
     }
    }
    );

    this.authService.gatePass.subscribe(
      gatePass=>{
        this.gatePass=gatePass

      }
    )

  }
  initDecisionStates(){
    this.admin_extend=this.current_server_enrolment_id!=0 && this.guardian && this.gatePass.is_role_admin

    this.can_change_level= this.current_server_enrolment_id!=0
    this.add_trial = this.gatePass.is_role_guardian|| this.gatePass.is_role_admin

    this.add_trial_admin = this.gatePass.is_role_admin
    this.admin_extend = this.gatePass.is_role_admin
    let is_current_valid=false
    if(this.subscription){
      is_current_valid= this.subscription.is_valid
    }


  }
  initGuardianStudent(){

    this.guardianService.getById(this.studentDetail.server_guardian_id).subscribe(
      x=>{
        this.guardian=x
      }
    )
  }

  adminUpgradeEnrolment(server_enrolment_id:number){
    this.adminUpgrading =true
    this.adminService.upgradeEnrolment(server_enrolment_id).subscribe(
      x=>{
        this.adminUpgrading=false
        this.enrollments.push(x)
      }
    )
  }
  adminExtendEnrolmentModalShow(enrolment_extend_id:number){
    this.enrolAdminExtendModal = new window.bootstrap.Modal(
      document.getElementById(this.adminEnrolExtendModalName)
    );
    this.enrolment_extend_id=enrolment_extend_id
    this.enrolAdminExtendModal.show()
  }


  addTrialEnrolmentPopup(){
    this.trialModal = new window.bootstrap.Modal(
      document.getElementById(this.myTrialEnrolmentModalName)
    );
    this.trialModal.show()
  }

  addUpgradeEnrolmentPopup(){
    this.upgradeModal = new window.bootstrap.Modal(
      document.getElementById(this.myUpgradeEnrolmentModalName)
    );
    this.upgradeModal.show()
  }

  closeModal(closeModalName:string){
      if(this.myTrialEnrolmentModalName==closeModalName){
         this.trialModal.hide()
      }else if(this.myUpgradeEnrolmentModalName==closeModalName){
        this.upgradeModal.hide()
      }else if(this.adminEnrolExtendModalName==closeModalName){
        this.enrolAdminExtendModal.hide()
      }
    this.loadEnrollments()
  }


  loadEnrollments(){
    this.studentService.getEnrollments(this.server_student_user_id).subscribe(
      myInfo=>{
        this.enrollments=myInfo['enrolments']
      }
    )
  }

  toggleTrialEnrolLoading(enrolLoading:boolean){
    this.enrolTrialLoading=enrolLoading
  }


  alertProvisioning(value:boolean){

  }

  }


